module.exports = __webpack_public_path__ + "static/img/nav_bg.cf035ccd.png";